import React from 'react';
import { theme } from 'lib/style';
import { PrimaryButton } from 'lib/components';
type Props = {
  icon?: JSX.Element;
  textColor?: string;
  backgroundColor?: string;
  border?: string;
  hoverBorder?: string;
  margin?: string;
  text?: string;
  height?: string;
  textPadding?: string;
  iconPadding?: string;
  fontSize?: number;
  disabled?: boolean;
  iconPlacement?: 'left' | 'right';
  width?: number;
  iconMargin?: string;
  onClick(): void;
};
export const ActionButton = ({
  icon,
  iconPlacement = 'left',
  textColor = theme.palette.gray100,
  backgroundColor = theme.palette.gray20,
  margin = '0 0 0 8px',
  textPadding = '8px 16px',
  iconPadding = '8px 0px 8px 12px',
  height = '40px',
  fontSize = 15,
  text = '',
  disabled = false,
  width,
  iconMargin,
  border,
  hoverBorder,
  onClick = () => {},
}: Props) => {
  return (
    <PrimaryButton
      height={height}
      text={text}
      margin={margin}
      borderRadius={5}
      textColor={textColor}
      backgroundColor={backgroundColor}
      fontSize={fontSize}
      textPadding={textPadding}
      icon={icon}
      iconPadding={iconPadding}
      onClick={onClick}
      disabled={disabled}
      center={true}
      iconPlacement={iconPlacement}
      width={width}
      iconMargin={iconMargin}
      border={border}
      hoverBorder={hoverBorder}
    />
  );
};
